<div *ngIf="isVisible" [ngClass]="['d-flex', 'align-items-center', 'mt-3']"
     [style.color]="iconColor"
     [style.backgroundColor]="backgroundColor"
     [style.border]="borderStyle"
     class="alert">

  <i *ngIf="type === 'info'" class="bi bi-info-circle-fill me-2"></i>
  <i *ngIf="type === 'success'" class="bi bi-check-circle-fill me-2"></i>
  <i *ngIf="type === 'error'" class="bi bi-exclamation-circle-fill me-2"></i>
    <div class="flex-grow-1" [innerHTML]="message"></div>

  <!-- Kapatma butonu -->
  <button *ngIf="closable" type="button" class="btn-close ms-auto" aria-label="Close" (click)="close()" [style.color]="iconColor">
    <i class="bi bi-x-circle"></i> <!-- Kapatma ikonu -->
  </button>
</div>
